import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:{{strokeColor}};}
    .st7{fill:none;stroke:{{strokeColor}};stroke-width:1.5;stroke-miterlimit:10;}
    .st9{fill:none;stroke:{{strokeColor}};stroke-miterlimit:10;}
  </style>
  <g>
    <rect x="3.1" y="5.5" class="st7" width="23.9" height="19"/>
    <rect x="11.3" y="8.3" class="st9" width="12.5" height="3.3"/>
    <rect x="5.5" y="8.8" class="st0" width="4.1" height="2.2"/>
    <rect x="5.5" y="14.5" class="st0" width="4.1" height="2.2"/>
    <rect x="10.7" y="19.4" class="st0" width="6.5" height="2.2"/>
    <rect x="17.8" y="19.4" class="st0" width="6.3" height="2.2"/>
    <rect x="11.3" y="13.8" class="st9" width="12.5" height="3.3"/>
    <path class="st0" d="M15,14.7c0,0.1,0,0.3-0.1,0.5l0,0.2l0.2-0.1c0.3-0.2,0.5-0.3,0.6-0.3c0.1,0,0.3,0.1,0.3,0.3
    c0,0.2-0.3,0.3-0.7,0.3l-0.2,0l0.1,0.1c0.3,0.2,0.5,0.4,0.5,0.5c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.5-0.6l-0.1-0.2l-0.1,0.2
    c-0.2,0.4-0.3,0.6-0.5,0.6c-0.2,0-0.3-0.1-0.3-0.2c0-0.2,0.2-0.3,0.5-0.5l0.1-0.1l-0.2,0c-0.5,0-0.7-0.1-0.7-0.3
    c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.6,0.3l0.2,0.1l0-0.2c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.2,0.1-0.3,0.3-0.3
    C14.9,14.4,15,14.5,15,14.7z"/>
    <path class="st0" d="M17.5,14.7c0,0.1,0,0.3-0.1,0.5l0,0.2l0.2-0.1c0.3-0.2,0.5-0.3,0.6-0.3c0.1,0,0.3,0.1,0.3,0.3
    c0,0.2-0.3,0.3-0.7,0.3l-0.2,0l0.1,0.1c0.3,0.2,0.5,0.4,0.5,0.5c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.5-0.6l-0.1-0.2l-0.1,0.2
    c-0.2,0.4-0.3,0.6-0.5,0.6c-0.2,0-0.3-0.1-0.3-0.2c0-0.2,0.2-0.3,0.5-0.5l0.1-0.1l-0.2,0c-0.5,0-0.7-0.1-0.7-0.3
    c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.6,0.3l0.2,0.1l0-0.2c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.2,0.1-0.3,0.3-0.3
    C17.4,14.4,17.5,14.5,17.5,14.7z"/>
    <path class="st0" d="M19.9,14.7c0,0.1,0,0.3-0.1,0.5l0,0.2l0.2-0.1c0.3-0.2,0.5-0.3,0.6-0.3c0.1,0,0.3,0.1,0.3,0.3
    c0,0.2-0.3,0.3-0.7,0.3l-0.2,0l0.1,0.1c0.3,0.2,0.5,0.4,0.5,0.5c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.3-0.2-0.5-0.6l-0.1-0.2l-0.1,0.2
    c-0.2,0.4-0.3,0.6-0.5,0.6c-0.2,0-0.3-0.1-0.3-0.2c0-0.2,0.2-0.3,0.5-0.5l0.1-0.1l-0.2,0c-0.5,0-0.7-0.1-0.7-0.3
    c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.6,0.3l0.2,0.1l0-0.2c-0.1-0.2-0.1-0.4-0.1-0.5c0-0.2,0.1-0.3,0.3-0.3
    C19.8,14.4,19.9,14.5,19.9,14.7z"/>
  </g>
</svg>
`

export const form: ComponentGroup = {
  name: 'form',
  description: 'a group of various input components that make up a data entry form',
  icon,
  templates: []
}
